import { useApiQuery } from '@common/hooks/query/useApiQuery';
import { SkipOrArgs } from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetOverrideHistoryQuery } from '../api';
import {
    DEFAULT_OVERRIDE_HISTORY_RESPONSE,
    GetOverrideHistoryArgs,
} from '../types';

export const useCollectionOverrideHistory = (
    args: SkipOrArgs<GetOverrideHistoryArgs>,
) => {
    const queryArgs = useMemo(() => {
        if (args === skipToken || !args.proscopeId) return skipToken;
        return args;
    }, [args]);

    const { data, ...queryResult } = useApiQuery(
        useGetOverrideHistoryQuery,
        queryArgs,
    );

    const history = useMemo(() => {
        return data ?? DEFAULT_OVERRIDE_HISTORY_RESPONSE;
    }, [data]);

    return {
        data: history,
        ...queryResult,
    };
};
